__webpack_require__.p = "/md-farid-portfolio/";